'use client';
import clsx from 'clsx';
import Image from 'next/image';
import React, { useState } from 'react';

import { openGameProvider } from '@/components/core/OpenGame';
import { useAppRouter } from '@/components/hooks/useAppRouter';

const ItemLive = (props: any) => {
  const item = props?.item;
  const index = props?.index;
  const { router } = useAppRouter();
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      onClick={() => openGameProvider(item, router)}
      key={item.img}
      className={clsx(
        'cursor-hand shadow-box-light relative aspect-square rounded-lg',
        !loaded && 'loading-bg',
        props?.className
      )}
    >
      <div className='shine-item h-full w-full'>
        {item.img && (
          <Image
            className='cursor-hand h-full w-full object-cover'
            src={item.img}
            width={392}
            height={186}
            alt='banner'
            onLoad={() => {
              setLoaded(true);
            }}
          />
        )}
      </div>
      {index === 0 && (
        <img
          className='absolute top-0 w-[35px]'
          src='/img/game/hot/hot-tag.png'
          alt='hot-tag'
        />
      )}
      {index === 1 && (
        <img
          className='absolute top-0 w-[35px]'
          src='/img/game/hot/new-tag.png'
          alt='new-tag'
        />
      )}
    </div>
  );
};

export default ItemLive;
